import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "21",
  viewBox: "0 0 20 20",
  width: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.5 9.16634L10 11.6663L18.3333 3.33301",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.66667"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.5 10V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H13.3333",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.66667"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "21",
  viewBox: "0 0 20 21",
  width: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.8333 3H4.16667C3.24619 3 2.5 3.74619 2.5 4.66667V16.3333C2.5 17.2538 3.24619 18 4.16667 18H15.8333C16.7538 18 17.5 17.2538 17.5 16.3333V4.66667C17.5 3.74619 16.7538 3 15.8333 3Z",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.66667"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
			'opacity-30': _ctx.disabled,
			'cursor-pointer': !_ctx.disabled && !_ctx.disabledAction,
		}),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [
    (_ctx.valueCheckbox)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.color || _ctx.disabled ? 'text-neutral-500' : 'text-yellow-500')
        }, _hoisted_2, 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{
				'hover:text-yellow-500': !_ctx.disabled && !_ctx.disabledAction,
			}, "text-neutral-400"])
        }, _hoisted_4, 2))
  ], 2))
}